<div *ngIf="uiService && uiService.headerState && uiService.headerState.visible" class="pageHeader">
  <div>
    <img *ngIf="imgSrc" [src]="imgSrc" class="logo">
    <page-header-title class="header-title header1"></page-header-title>
    <languages-button *ngIf="showLanguagesButton" class="lang {{languageButtonActivate}}">
    </languages-button>
    <app-basket-button class="basket-button"></app-basket-button>
    <app-notification-message *ngIf="notificationMessage" [message]="notificationMessage?.message"
      [type]="notificationMessage?.type"></app-notification-message>
  </div>
  <div style="clear:both;"></div>
</div>
